<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import { DATA_TYPE } from '@/store/modules/cards/constants';
import EventBus from '@/utils/event-bus';
import { formatSocialNumberWithDecimal } from '@/utils/formatter';

export default {
  name: 'OwnedEarnedPotentialReach',
  components: {
    SimpleDataWithVariation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getSacListeningWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      const promisses = [
        this.getSacListeningWarroomService({
          itemId: this.itemId,
          servicePath: 'monitoringOverview',
          filterType: DATA_TYPE.LISTENING,
        }),
        this.getSacListeningWarroomService({
          itemId: this.itemId,
          servicePath: 'monitoringOverview',
          filterType: DATA_TYPE.SAC,
        })];
      Promise.all(
        promisses
      ).then(([responseListening, responseSac]) => {
        this.value = responseListening.potential_reach + responseSac.potential_reach;
        this.variation = responseListening.potential_reach_variation + responseSac.potential_reach_variation;
        this.rawVariation = responseListening.potential_reach_variation + responseSac.potential_reach_variation;
        this.comparationValue = formatSocialNumberWithDecimal(responseListening.previous_potential_reach + responseSac.previous_potential_reach);
        this.requestStatus = 'success';

        if (options?.silentRefresh) {
          EventBus.$emit('updated', { itemId: this.itemId });
        }
      })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
